import React, {useContext, useState} from "react";
import {TrafficLightDeviceOverviewContext} from "../context/TrafficLightOverviewContext";
import {
    IP_ADDRESS_PATTERN,
    isValidEntry,
    MAC_MASK,
    PATTERNS,
    validateNewControllerDevice
} from "../../../util/Validations";
import Modal, {ModalFooter} from "@amzn/meridian/modal";
import Column from "@meridian/components/column";
import Text from "@amzn/meridian/text";
import {FormattedMessage} from "react-intl";
import Input from "@amzn/meridian/input";
import Alert from "@amzn/meridian/alert";
import Row from "@amzn/meridian/row";
import Button from "@amzn/meridian/button";

const AddControllerModal = ({open, setOpen}) => {
    const {dispatch} = useContext(TrafficLightDeviceOverviewContext);

    const [showAlert, setShowAlert] = useState(false)

    const [name, setName] = useState("")
    const [ip, setIp] = useState("")
    const [mac, setMac] = useState("")

    const [nameErr, setNameErr] = useState(false)
    const [ipErr, setIpErr] = useState(false)
    const [macErr, setMacErr] = useState(false)

    const onCloseModal = () => {
        setOpen(false);
        resetInputState();
        setShowAlert(false);
    }

    const addAsset = () => {
        dispatch({type: 'ADD_CONTROLLER_DATA', data: {dispatcher: dispatch, assetDetails: { mac, ip, name }}})
    }

    const onClickConfirm = () => {
        if(validateNewControllerDevice(mac, ip, name)) {
            setShowAlert(false);
            addAsset();
            resetInputState();
            setOpen(false);
        } else {
            setShowAlert(true);
        }
    }

    function resetInputState() {
        resetAssetDetails();
        resetAssetDetailErrors();
    }

    const resetAssetDetails = () => {
        setMac("")
        setIp("");
        setName("");
    }

    const resetAssetDetailErrors = () => {
        setMacErr(false)
        setIpErr(false);
        setNameErr(false);
    }

    return(
        <Modal
            open={open}
            onClose={onCloseModal}
            scrollContainer="viewport"
            closeLabel="Close"
            bodySpacingInset="medium"
            width="100%"
        >
            <Column spacing={"medium"} spacingInset={"medium"}>
                <Column spacing="200">
                    <Text tag="label" type="b200" color="primary" htmlFor="mac-input">
                        <FormattedMessage id="modal.mac" defaultMessage="MAC Address"/>
                    </Text>
                    <Input id="mac-input"
                           value={mac}
                           onChange={setMac}
                           mask={MAC_MASK}
                           onBlur={() => {
                               setMacErr(!isValidEntry(mac, PATTERNS.MAC))
                           }}
                           error={macErr}
                    />
                </Column>
                <Column spacing="200">
                    <Text tag="label" type="b200" color="primary" htmlFor="ip-input">
                        <FormattedMessage id="modal.ip" defaultMessage="IP Address"/>
                    </Text>
                    <Input id="ip-input"
                           value={ip}
                           onChange={setIp}
                           onBlur={() => setIpErr(!isValidEntry(ip, IP_ADDRESS_PATTERN))}
                           error={ipErr}
                    />
                </Column>
                <Column spacing="200">
                    <Text tag="label" type="b200" color="primary" htmlFor="name-input">
                        <FormattedMessage id="modal.name"
                                          defaultMessage="Device Name"/>
                    </Text>
                    <Input id="name-input"
                           value={name}
                           onChange={setName}
                           onBlur={() => setNameErr(!isValidEntry(name, PATTERNS.NAME))}
                           error={nameErr}
                           helperText={"Display name of the device. e.g. \"Controller 1\""}
                    />
                </Column>
            </Column>
            <ModalFooter>
                <Column>
                    {showAlert && <Alert type="warning" size="small">
                        <FormattedMessage id="alert.missingfields"
                                          defaultMessage="Please enter all fields in correct format!"/>
                    </Alert>}
                </Column>
                <Row alignmentHorizontal="right" widths="fit">
                    <Button type="secondary" size="medium" onClick={onCloseModal}>
                        <FormattedMessage id="modal.cancel" defaultMessage="Cancel"/>
                    </Button>
                    <Button type="primary"
                            size="medium"
                            onClick={onClickConfirm}>
                        <FormattedMessage id="modal.confirmAdd" defaultMessage="Confirm add"/>
                    </Button>
                </Row>
            </ModalFooter>
        </Modal>
    )
}

export default AddControllerModal;


// WEBPACK FOOTER //
// ./src/components/devicemanagement/trafficlightdevice/modal/AddControllerModal.js